import { Button, Col, Form, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import planningService from "@services/planning.service";
import qs from "qs";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

const Search = ({ loading }) => {
  const [searchParams, setSearchParams] = useState({});
  const [regions, setRegions] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [cities, setCities] = useState({
    loading: false,
    data: [],
    error: null,
  });
  const [sites, setSites] = useState({
    loading: false,
    data: [],
    error: null,
  });

  const [form] = Form.useForm();

  const { search } = useLocation();
  const history = useHistory();

  async function fetchRegions() {
    setRegions({ ...regions, loading: true });

    try {
      const res = await planningService.fetchRegions();

      setRegions({
        ...regions,
        loading: false,
        data: res.data.map((r) => ({ label: r, value: r })),
      });
    } catch (error) {
      console.log(error);
      setRegions({ ...regions, loading: false, error: error });
    }
  }

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.fetchProvinces();
      setProvinces({
        ...provinces,
        loading: false,
        data: res.data.map((p) => ({ label: p, value: p })),
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchCities() {
    setCities({ ...cities, loading: true });

    try {
      const res = await planningService.fetchCities();
      setCities({
        ...cities,
        loading: false,
        data: res.data.map((c) => ({ label: c, value: c })),
      });
    } catch (error) {
      console.log(error);
      setCities({ ...cities, loading: false, error: error });
    }
  }

  async function fetchSites() {
    setSites({ ...sites, loading: true });

    try {
      const res = await planningService.fetchSites();
      setSites({
        ...sites,
        loading: false,
        data: res.data.map((s) => ({ label: s, value: s })),
      });
    } catch (error) {
      console.log(error);
      setSites({ ...sites, loading: false, error: error });
    }
  }

  function fetchDatas() {
    fetchProvinces();
    fetchRegions();
    fetchCities();
    fetchSites();
  }

  const onFinish = async (values) => {
    try {
      history.push(
        `?${qs.stringify({
          ...values,
        })}`
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    // const urlParams = new URLSearchParams(search);
    // const params = Object.fromEntries(urlParams);
    const params = qs.parse(search.substring(1, search.length));
    setSearchParams(params);
  }, [search]);

  useEffect(() => {
    form.setFieldsValue({
      ...searchParams,
      //   oss: searchParams.oss || "OSS9",
      //   datetime: moment(searchParams.datetime),
    });
    // eslint-disable-next-line
  }, [searchParams]);

  useEffect(() => {
    fetchDatas();
  }, []);

  return (
    <div className="bg-white rounded-md border border-gray-200 p-5">
      <Form
        form={form}
        layout="vertical"
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
        initialValues={{}}
      >
        <Row gutter={[14, 0]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="region"
              label="Region"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                maxTagCount={5}
                options={regions.data}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="province"
              label="Province"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                maxTagCount={5}
                options={provinces.data}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="city"
              label="City"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                maxTagCount={5}
                options={cities.data}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="site"
              label="Site"
              rules={[
                {
                  type: "array",
                  // required: true,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                maxTagCount={5}
                options={sites.data}
              />
            </Form.Item>
          </Col>

          <Col flex="auto" className="flex justify-end items-end">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading}
                className="mt-4"
              >
                View
              </Button>
              <Button
                style={{ margin: "0 8px" }}
                onClick={() => {
                  form.resetFields();
                }}
              >
                Clear
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Search;
